var render = function render(){
  var _vm$getProviderEnum, _vm$$master, _vm$data, _vm$data$orderDetail, _vm$$provider, _vm$data2, _vm$data2$orderDetail, _vm$data3, _vm$data3$orderDetail, _vm$data3$orderDetail2, _vm$data4, _vm$data4$orderDetail, _vm$data4$orderDetail2, _vm$data5, _vm$data5$orderDetail, _vm$data5$orderDetail2, _vm$data6, _vm$data6$orderDetail, _vm$data6$orderDetail2, _vm$data$orderDetail2, _vm$data$orderDetail3, _vm$$helper, _vm$data$orderDetail4, _vm$data7, _vm$data7$orderDetail, _vm$data7$orderDetail2, _vm$data7$orderDetail3, _vm$data8, _vm$data8$orderDetail, _vm$data8$orderDetail2, _vm$data8$orderDetail3, _vm$$helper$findColor, _vm$$masterCrm, _vm$data9, _vm$data9$orderDetail, _vm$data9$orderDetail2, _vm$data9$orderDetail3, _vm$data10, _vm$data10$orderDetai, _vm$data10$orderDetai2, _vm$data10$orderDetai3, _vm$data11, _vm$data11$orderDetai, _vm$data11$orderDetai2, _vm$data11$orderDetai3, _vm$$helper2, _vm$data12, _vm$data12$orderDetai, _vm$data12$orderDetai2, _vm$data12$orderDetai3, _vm$data13, _vm$data13$orderDetai, _vm$data13$orderDetai2, _vm$data13$orderDetai3, _vm$data14, _vm$data14$orderDetai, _vm$data14$orderDetai2, _vm$data14$orderDetai3, _vm$$helper$findColor2, _vm$$masterCrm2, _vm$data15, _vm$data15$orderDetai, _vm$data15$orderDetai2, _vm$data15$orderDetai3, _vm$data16, _vm$data16$orderDetai, _vm$data16$orderDetai2, _vm$data16$orderDetai3, _vm$data17, _vm$data17$orderDetai, _vm$data17$orderDetai2, _vm$data17$orderDetai3, _vm$$helper3, _vm$data18, _vm$data18$orderDetai, _vm$data18$orderDetai2, _vm$data18$orderDetai3, _vm$data19, _vm$data19$orderDetai, _vm$data19$orderDetai2, _vm$data19$orderDetai3, _vm$data20, _vm$data20$orderDetai, _vm$data21, _vm$data21$orderDetai, _vm$data21$orderDetai2, _vm$data21$orderDetai3, _vm$data22, _vm$data22$orderDetai, _vm$data22$orderDetai2, _vm$data22$orderDetai3, _vm$$helper$findColor3, _vm$$masterCrm3, _vm$data23, _vm$data23$orderDetai, _vm$data23$orderDetai2, _vm$data23$orderDetai3, _vm$data24, _vm$data24$orderDetai, _vm$data24$orderDetai2, _vm$data24$orderDetai3, _vm$data25, _vm$data25$orderDetai, _vm$data25$orderDetai2, _vm$data25$orderDetai3, _vm$$helper4, _vm$data26, _vm$data26$orderDetai, _vm$data26$orderDetai2, _vm$data26$orderDetai3, _vm$data27, _vm$data27$orderDetai, _vm$data27$orderDetai2, _vm$data27$orderDetai3, _vm$data28, _vm$data28$orderDetai, _vm$data28$orderDetai2, _vm$data28$orderDetai3, _vm$$helper$findColor4, _vm$$masterCrm4, _vm$data29, _vm$data29$orderDetai, _vm$data29$orderDetai2, _vm$data29$orderDetai3, _vm$data30, _vm$data30$orderDetai, _vm$data30$orderDetai2, _vm$data30$orderDetai3, _vm$data31, _vm$data31$orderDetai, _vm$data31$orderDetai2, _vm$data31$orderDetai3, _vm$$helper5, _vm$data32, _vm$data32$orderDetai, _vm$data32$orderDetai2, _vm$data32$orderDetai3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row border-top-light-blue bg-white pt10 order-loading",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "font18 pr24 pl24",
    staticStyle: {
      "width": "100%",
      "font-weight": "600 !important",
      "margin-bottom": "-22px",
      "display": "inline-block"
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left pointer",
    staticStyle: {
      "margin-right": "18px",
      "cursor": "pointer"
    },
    attrs: {
      "title": "Back"
    },
    on: {
      "click": _vm.goBack
    }
  }), _c('span', [_vm._v("Special Blend Order Detail")]), _c('button', {
    staticClass: "btn btn-info btn-sm go-right",
    on: {
      "click": _vm.printOrder
    }
  }, [_c('i', {
    staticClass: "fa fa-print mr3"
  }), _vm._v(" Export PDF ")]), _c('hr')]), !_vm.isFetching ? _c('div', {
    attrs: {
      "id": "order-report"
    }
  }, [_c('div', {
    staticClass: "row pt24 pr24 pl24 pt10"
  }, [_c('div', {
    staticClass: "col-6 col-md-6 p4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "list-group"
  }, [_vm._m(0), _c('li', [_vm._m(1), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(": #" + _vm._s(_vm.data.orderDetail.invoiceNumber))])]), _c('li', [_vm._m(2), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(": " + _vm._s(_vm.data.orderDetail.transactionNumber))])]), _c('li', [_vm._m(3), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(": " + _vm._s(_vm.data.orderDetail.paymentMethod.name))])]), _c('li', [_vm._m(4), _c('div', {
    staticClass: "col-7 text-capitalize"
  }, [_vm._v(" : " + _vm._s(_vm.data.orderDetail.shippingMethod) + " ")])]), _c('li', [_vm._m(5), _c('div', {
    staticClass: "col-7 text-capitalize"
  }, [_vm._v(" : " + _vm._s(_vm.data.orderDetail.addressDetail) + " ")])]), _c('li', [_vm._m(6), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(" : $" + _vm._s(_vm.data.orderDetail.paymentDetail.shippingRate.toFixed(2)) + " ")])]), _c('li', [_vm._m(7), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(" : " + _vm._s(_vm.data.orderDetail.createdAt && _vm.$helper.formatDate(_vm.data.orderDetail.createdAt)) + " ")])]), _c('li', [_vm._m(8), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(": " + _vm._s(_vm.data.orderDetail.orderStatus.name))])]), _c('li', [_vm._m(9), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(": " + _vm._s(_vm.data.orderDetail.rewardPoints))])]), _c('li', [_vm._m(10), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(" : " + _vm._s(((_vm$getProviderEnum = _vm.getProviderEnum((_vm$$master = _vm.$master) === null || _vm$$master === void 0 ? void 0 : _vm$$master.branches, (_vm$data = _vm.data) === null || _vm$data === void 0 ? void 0 : (_vm$data$orderDetail = _vm$data.orderDetail) === null || _vm$data$orderDetail === void 0 ? void 0 : _vm$data$orderDetail.branchId)) === null || _vm$getProviderEnum === void 0 ? void 0 : _vm$getProviderEnum.name) || "N/A") + " ")])]), _c('li', [_vm._m(11), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(" : " + _vm._s(_vm.getProviderEnum((_vm$$provider = _vm.$provider) === null || _vm$$provider === void 0 ? void 0 : _vm$$provider.orderProviderEnum, (_vm$data2 = _vm.data) === null || _vm$data2 === void 0 ? void 0 : (_vm$data2$orderDetail = _vm$data2.orderDetail) === null || _vm$data2$orderDetail === void 0 ? void 0 : _vm$data2$orderDetail.provider).name) + " ")])]), _c('li', [_vm._m(12), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(": " + _vm._s(_vm.data.orderDetail.remark || "N/A"))])])])])]), _c('div', {
    staticClass: "col-6 col-md-6"
  }, [_c('div', {
    staticClass: "row ph4 pt4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "list-group"
  }, [_vm._m(13), _c('li', [_vm._m(14), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(" : " + _vm._s([((_vm$data3 = _vm.data) === null || _vm$data3 === void 0 ? void 0 : (_vm$data3$orderDetail = _vm$data3.orderDetail) === null || _vm$data3$orderDetail === void 0 ? void 0 : (_vm$data3$orderDetail2 = _vm$data3$orderDetail.account) === null || _vm$data3$orderDetail2 === void 0 ? void 0 : _vm$data3$orderDetail2.firstName) || 'N/A', ((_vm$data4 = _vm.data) === null || _vm$data4 === void 0 ? void 0 : (_vm$data4$orderDetail = _vm$data4.orderDetail) === null || _vm$data4$orderDetail === void 0 ? void 0 : (_vm$data4$orderDetail2 = _vm$data4$orderDetail.account) === null || _vm$data4$orderDetail2 === void 0 ? void 0 : _vm$data4$orderDetail2.lastName) || 'N/A'].join(' ')) + " ")])]), _c('li', [_vm._m(15), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(" : " + _vm._s(((_vm$data5 = _vm.data) === null || _vm$data5 === void 0 ? void 0 : (_vm$data5$orderDetail = _vm$data5.orderDetail) === null || _vm$data5$orderDetail === void 0 ? void 0 : (_vm$data5$orderDetail2 = _vm$data5$orderDetail.account) === null || _vm$data5$orderDetail2 === void 0 ? void 0 : _vm$data5$orderDetail2.contactEmail) || 'N/A') + " ")])]), _c('li', [_vm._m(16), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(" : " + _vm._s(_vm.$helper.formatPhoneNumber((_vm$data6 = _vm.data) === null || _vm$data6 === void 0 ? void 0 : (_vm$data6$orderDetail = _vm$data6.orderDetail) === null || _vm$data6$orderDetail === void 0 ? void 0 : (_vm$data6$orderDetail2 = _vm$data6$orderDetail.account) === null || _vm$data6$orderDetail2 === void 0 ? void 0 : _vm$data6$orderDetail2.contactPhone) || 'N/A') + " ")])])])]), _c('div', {
    staticClass: "row mt10"
  }, [_c('ul', {
    staticClass: "list-group"
  }, [_vm._m(17), _c('li', [_vm._m(18), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(" : "), _vm.data.orderDetail.paymentDetail.couponCode ? _c('div', {
    staticStyle: {
      "display": "initial"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.data.orderDetail.paymentDetail.couponCode) + " / ")]), _vm.data.orderDetail.paymentDetail.couponType == 'percentage' ? _c('span', [_vm._v(" " + _vm._s(_vm.data.orderDetail.paymentDetail.couponDiscount) + " % ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.$helper.formatPrice(_vm.data.orderDetail.paymentDetail.couponDiscount)) + " ")])]) : _vm._e()])]), _c('li', [_vm._m(19), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(" : " + _vm._s(!_vm.data.orderDetail.paymentDetail.couponFreeShipping ? 'Charged' : 'Free') + " ")])]), _c('li', [_vm._m(20), _c('div', {
    staticClass: "col-7 text-capitalize"
  }, [_vm._v(" : "), _vm.data.orderDetail.paymentDetail.paymentStatus == 'success' ? _c('span', {
    staticClass: "txt-success"
  }, [_vm._v(_vm._s(_vm.data.orderDetail.paymentDetail.paymentStatus))]) : _vm.data.orderDetail.paymentDetail.paymentStatus == 'pending' ? _c('span', {
    staticClass: "txt-warning"
  }, [_vm._v(_vm._s(_vm.data.orderDetail.paymentDetail.paymentStatus))]) : _c('span', {
    staticClass: "txt-danger"
  }, [_vm._v(_vm._s(_vm.data.orderDetail.paymentDetail.paymentStatus))])])])])])])])]), _c('div', {
    staticClass: "row pr24 pl24 pt10"
  }, [_c('div', {
    staticClass: "col-6 col-md-6 p4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "list-group"
  }, [_vm._m(21), _c('li', [_vm._m(22), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(" : " + _vm._s(_vm.data.orderDetail.deliveryOptionLabel || "N/A") + " ")])]), _c('li', [_vm._m(23), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(" : " + _vm._s(((_vm$data$orderDetail2 = _vm.data.orderDetail) === null || _vm$data$orderDetail2 === void 0 ? void 0 : _vm$data$orderDetail2.addressDetail) || "N/A") + " ")])]), _c('li', [_vm._m(24), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(" : " + _vm._s(((_vm$data$orderDetail3 = _vm.data.orderDetail) === null || _vm$data$orderDetail3 === void 0 ? void 0 : _vm$data$orderDetail3.deliveryPersonName) || "N/A") + " ")])]), _c('li', [_vm._m(25), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(" : " + _vm._s((_vm$$helper = _vm.$helper) === null || _vm$$helper === void 0 ? void 0 : _vm$$helper.formatPhoneNumber((_vm$data$orderDetail4 = _vm.data.orderDetail) === null || _vm$data$orderDetail4 === void 0 ? void 0 : _vm$data$orderDetail4.deliveryPhoneNumber)) + " ")])])])])]), _c('div', {
    staticClass: "col-6 col-md-6"
  }, [_c('div', {
    staticClass: "row ph4 pt4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "list-group list-group-delivery-status"
  }, [_vm._m(26), _c('li', [_c('div', {
    staticClass: "row list-group-item"
  }, [_c('span', {
    style: `color: ${(_vm$data7 = _vm.data) !== null && _vm$data7 !== void 0 && (_vm$data7$orderDetail = _vm$data7.orderDetail) !== null && _vm$data7$orderDetail !== void 0 && (_vm$data7$orderDetail2 = _vm$data7$orderDetail.deliveryActivity) !== null && _vm$data7$orderDetail2 !== void 0 && (_vm$data7$orderDetail3 = _vm$data7$orderDetail2.waitingToDeliver) !== null && _vm$data7$orderDetail3 !== void 0 && _vm$data7$orderDetail3.deliveryStatusId ? 'var(--primary)' : ''}`
  }, [_c('c-success'), _c('span', {
    style: `color: ${(_vm$data8 = _vm.data) !== null && _vm$data8 !== void 0 && (_vm$data8$orderDetail = _vm$data8.orderDetail) !== null && _vm$data8$orderDetail !== void 0 && (_vm$data8$orderDetail2 = _vm$data8$orderDetail.deliveryActivity) !== null && _vm$data8$orderDetail2 !== void 0 && (_vm$data8$orderDetail3 = _vm$data8$orderDetail2.waitingToDeliver) !== null && _vm$data8$orderDetail3 !== void 0 && _vm$data8$orderDetail3.deliveryStatusId ? 'var(--primary)' : ''}`
  }, [_vm._v(" " + _vm._s(((_vm$$helper$findColor = _vm.$helper.findColor((_vm$$masterCrm = _vm.$masterCrm) === null || _vm$$masterCrm === void 0 ? void 0 : _vm$$masterCrm.CrmDeliveryStatus, (_vm$data9 = _vm.data) === null || _vm$data9 === void 0 ? void 0 : (_vm$data9$orderDetail = _vm$data9.orderDetail) === null || _vm$data9$orderDetail === void 0 ? void 0 : (_vm$data9$orderDetail2 = _vm$data9$orderDetail.deliveryActivity) === null || _vm$data9$orderDetail2 === void 0 ? void 0 : (_vm$data9$orderDetail3 = _vm$data9$orderDetail2.waitingToDeliver) === null || _vm$data9$orderDetail3 === void 0 ? void 0 : _vm$data9$orderDetail3.deliveryStatusId, ['id'])) === null || _vm$$helper$findColor === void 0 ? void 0 : _vm$$helper$findColor.name) || 'Waiting To Deliver') + " ")])], 1), (_vm$data10 = _vm.data) !== null && _vm$data10 !== void 0 && (_vm$data10$orderDetai = _vm$data10.orderDetail) !== null && _vm$data10$orderDetai !== void 0 && (_vm$data10$orderDetai2 = _vm$data10$orderDetai.deliveryActivity) !== null && _vm$data10$orderDetai2 !== void 0 && (_vm$data10$orderDetai3 = _vm$data10$orderDetai2.waitingToDeliver) !== null && _vm$data10$orderDetai3 !== void 0 && _vm$data10$orderDetai3.deliveryReason ? _c('span', {
    staticStyle: {
      "padding-left": "35px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v("Reason :")]), _c('span', {
    staticStyle: {
      "font-weight": "400",
      "color": "#000000"
    }
  }, [_vm._v(" " + _vm._s(((_vm$data11 = _vm.data) === null || _vm$data11 === void 0 ? void 0 : (_vm$data11$orderDetai = _vm$data11.orderDetail) === null || _vm$data11$orderDetai === void 0 ? void 0 : (_vm$data11$orderDetai2 = _vm$data11$orderDetai.deliveryActivity) === null || _vm$data11$orderDetai2 === void 0 ? void 0 : (_vm$data11$orderDetai3 = _vm$data11$orderDetai2.waitingToDeliver) === null || _vm$data11$orderDetai3 === void 0 ? void 0 : _vm$data11$orderDetai3.deliveryReason) || "N/A") + " ")])]) : _vm._e()]), _c('div', {
    staticClass: "row list-group-item"
  }, [_vm._v(" " + _vm._s((_vm$$helper2 = _vm.$helper) === null || _vm$$helper2 === void 0 ? void 0 : _vm$$helper2.formatDate((_vm$data12 = _vm.data) === null || _vm$data12 === void 0 ? void 0 : (_vm$data12$orderDetai = _vm$data12.orderDetail) === null || _vm$data12$orderDetai === void 0 ? void 0 : (_vm$data12$orderDetai2 = _vm$data12$orderDetai.deliveryActivity) === null || _vm$data12$orderDetai2 === void 0 ? void 0 : (_vm$data12$orderDetai3 = _vm$data12$orderDetai2.waitingToDeliver) === null || _vm$data12$orderDetai3 === void 0 ? void 0 : _vm$data12$orderDetai3.createdAt)) + " ")])]), _c('li', [_c('div', {
    staticClass: "row list-group-item"
  }, [_c('span', {
    style: `color: ${(_vm$data13 = _vm.data) !== null && _vm$data13 !== void 0 && (_vm$data13$orderDetai = _vm$data13.orderDetail) !== null && _vm$data13$orderDetai !== void 0 && (_vm$data13$orderDetai2 = _vm$data13$orderDetai.deliveryActivity) !== null && _vm$data13$orderDetai2 !== void 0 && (_vm$data13$orderDetai3 = _vm$data13$orderDetai2.onDelivery) !== null && _vm$data13$orderDetai3 !== void 0 && _vm$data13$orderDetai3.deliveryStatusId ? 'var(--primary)' : ''}`
  }, [_c('c-success'), _c('span', {
    style: `color: ${(_vm$data14 = _vm.data) !== null && _vm$data14 !== void 0 && (_vm$data14$orderDetai = _vm$data14.orderDetail) !== null && _vm$data14$orderDetai !== void 0 && (_vm$data14$orderDetai2 = _vm$data14$orderDetai.deliveryActivity) !== null && _vm$data14$orderDetai2 !== void 0 && (_vm$data14$orderDetai3 = _vm$data14$orderDetai2.onDelivery) !== null && _vm$data14$orderDetai3 !== void 0 && _vm$data14$orderDetai3.deliveryStatusId ? 'var(--primary)' : ''}`
  }, [_vm._v(" " + _vm._s(((_vm$$helper$findColor2 = _vm.$helper.findColor((_vm$$masterCrm2 = _vm.$masterCrm) === null || _vm$$masterCrm2 === void 0 ? void 0 : _vm$$masterCrm2.CrmDeliveryStatus, (_vm$data15 = _vm.data) === null || _vm$data15 === void 0 ? void 0 : (_vm$data15$orderDetai = _vm$data15.orderDetail) === null || _vm$data15$orderDetai === void 0 ? void 0 : (_vm$data15$orderDetai2 = _vm$data15$orderDetai.deliveryActivity) === null || _vm$data15$orderDetai2 === void 0 ? void 0 : (_vm$data15$orderDetai3 = _vm$data15$orderDetai2.onDelivery) === null || _vm$data15$orderDetai3 === void 0 ? void 0 : _vm$data15$orderDetai3.deliveryStatusId, ['id'])) === null || _vm$$helper$findColor2 === void 0 ? void 0 : _vm$$helper$findColor2.name) || 'On Delivery') + " ")])], 1), (_vm$data16 = _vm.data) !== null && _vm$data16 !== void 0 && (_vm$data16$orderDetai = _vm$data16.orderDetail) !== null && _vm$data16$orderDetai !== void 0 && (_vm$data16$orderDetai2 = _vm$data16$orderDetai.deliveryActivity) !== null && _vm$data16$orderDetai2 !== void 0 && (_vm$data16$orderDetai3 = _vm$data16$orderDetai2.onDelivery) !== null && _vm$data16$orderDetai3 !== void 0 && _vm$data16$orderDetai3.deliveryReason ? _c('span', {
    staticStyle: {
      "padding-left": "35px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v("Reason :")]), _c('span', {
    staticStyle: {
      "font-weight": "400",
      "color": "#000000"
    }
  }, [_vm._v(" " + _vm._s(((_vm$data17 = _vm.data) === null || _vm$data17 === void 0 ? void 0 : (_vm$data17$orderDetai = _vm$data17.orderDetail) === null || _vm$data17$orderDetai === void 0 ? void 0 : (_vm$data17$orderDetai2 = _vm$data17$orderDetai.deliveryActivity) === null || _vm$data17$orderDetai2 === void 0 ? void 0 : (_vm$data17$orderDetai3 = _vm$data17$orderDetai2.onDelivery) === null || _vm$data17$orderDetai3 === void 0 ? void 0 : _vm$data17$orderDetai3.deliveryReason) || "N/A") + " ")])]) : _vm._e()]), _c('div', {
    staticClass: "row list-group-item"
  }, [_vm._v(" " + _vm._s((_vm$$helper3 = _vm.$helper) === null || _vm$$helper3 === void 0 ? void 0 : _vm$$helper3.formatDate((_vm$data18 = _vm.data) === null || _vm$data18 === void 0 ? void 0 : (_vm$data18$orderDetai = _vm$data18.orderDetail) === null || _vm$data18$orderDetai === void 0 ? void 0 : (_vm$data18$orderDetai2 = _vm$data18$orderDetai.deliveryActivity) === null || _vm$data18$orderDetai2 === void 0 ? void 0 : (_vm$data18$orderDetai3 = _vm$data18$orderDetai2.onDelivery) === null || _vm$data18$orderDetai3 === void 0 ? void 0 : _vm$data18$orderDetai3.createdAt)) + " ")])]), ((_vm$data19 = _vm.data) === null || _vm$data19 === void 0 ? void 0 : (_vm$data19$orderDetai = _vm$data19.orderDetail) === null || _vm$data19$orderDetai === void 0 ? void 0 : (_vm$data19$orderDetai2 = _vm$data19$orderDetai.deliveryActivity) === null || _vm$data19$orderDetai2 === void 0 ? void 0 : (_vm$data19$orderDetai3 = _vm$data19$orderDetai2.returned) === null || _vm$data19$orderDetai3 === void 0 ? void 0 : _vm$data19$orderDetai3.deliveryStatusId) === ((_vm$data20 = _vm.data) === null || _vm$data20 === void 0 ? void 0 : (_vm$data20$orderDetai = _vm$data20.orderDetail) === null || _vm$data20$orderDetai === void 0 ? void 0 : _vm$data20$orderDetai.deliveryStatusId) ? _c('li', [_c('div', {
    staticClass: "row list-group-item"
  }, [_c('span', {
    style: `color: ${(_vm$data21 = _vm.data) !== null && _vm$data21 !== void 0 && (_vm$data21$orderDetai = _vm$data21.orderDetail) !== null && _vm$data21$orderDetai !== void 0 && (_vm$data21$orderDetai2 = _vm$data21$orderDetai.deliveryActivity) !== null && _vm$data21$orderDetai2 !== void 0 && (_vm$data21$orderDetai3 = _vm$data21$orderDetai2.returned) !== null && _vm$data21$orderDetai3 !== void 0 && _vm$data21$orderDetai3.deliveryStatusId ? 'var(--primary)' : ''}`
  }, [_c('c-returned'), _c('span', {
    style: `color: ${(_vm$data22 = _vm.data) !== null && _vm$data22 !== void 0 && (_vm$data22$orderDetai = _vm$data22.orderDetail) !== null && _vm$data22$orderDetai !== void 0 && (_vm$data22$orderDetai2 = _vm$data22$orderDetai.deliveryActivity) !== null && _vm$data22$orderDetai2 !== void 0 && (_vm$data22$orderDetai3 = _vm$data22$orderDetai2.returned) !== null && _vm$data22$orderDetai3 !== void 0 && _vm$data22$orderDetai3.deliveryStatusId ? 'var(--primary)' : ''}`
  }, [_vm._v(" " + _vm._s(((_vm$$helper$findColor3 = _vm.$helper.findColor((_vm$$masterCrm3 = _vm.$masterCrm) === null || _vm$$masterCrm3 === void 0 ? void 0 : _vm$$masterCrm3.CrmDeliveryStatus, (_vm$data23 = _vm.data) === null || _vm$data23 === void 0 ? void 0 : (_vm$data23$orderDetai = _vm$data23.orderDetail) === null || _vm$data23$orderDetai === void 0 ? void 0 : (_vm$data23$orderDetai2 = _vm$data23$orderDetai.deliveryActivity) === null || _vm$data23$orderDetai2 === void 0 ? void 0 : (_vm$data23$orderDetai3 = _vm$data23$orderDetai2.returned) === null || _vm$data23$orderDetai3 === void 0 ? void 0 : _vm$data23$orderDetai3.deliveryStatusId, ['id'])) === null || _vm$$helper$findColor3 === void 0 ? void 0 : _vm$$helper$findColor3.name) || 'Returned') + " ")])], 1), (_vm$data24 = _vm.data) !== null && _vm$data24 !== void 0 && (_vm$data24$orderDetai = _vm$data24.orderDetail) !== null && _vm$data24$orderDetai !== void 0 && (_vm$data24$orderDetai2 = _vm$data24$orderDetai.deliveryActivity) !== null && _vm$data24$orderDetai2 !== void 0 && (_vm$data24$orderDetai3 = _vm$data24$orderDetai2.returned) !== null && _vm$data24$orderDetai3 !== void 0 && _vm$data24$orderDetai3.deliveryReason ? _c('span', {
    staticStyle: {
      "padding-left": "35px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v("Reason :")]), _c('span', {
    staticStyle: {
      "font-weight": "400",
      "color": "#000000"
    }
  }, [_vm._v(" " + _vm._s(((_vm$data25 = _vm.data) === null || _vm$data25 === void 0 ? void 0 : (_vm$data25$orderDetai = _vm$data25.orderDetail) === null || _vm$data25$orderDetai === void 0 ? void 0 : (_vm$data25$orderDetai2 = _vm$data25$orderDetai.deliveryActivity) === null || _vm$data25$orderDetai2 === void 0 ? void 0 : (_vm$data25$orderDetai3 = _vm$data25$orderDetai2.returned) === null || _vm$data25$orderDetai3 === void 0 ? void 0 : _vm$data25$orderDetai3.deliveryReason) || "N/A") + " ")])]) : _vm._e()]), _c('div', {
    staticClass: "row list-group-item"
  }, [_vm._v(" " + _vm._s((_vm$$helper4 = _vm.$helper) === null || _vm$$helper4 === void 0 ? void 0 : _vm$$helper4.formatDate((_vm$data26 = _vm.data) === null || _vm$data26 === void 0 ? void 0 : (_vm$data26$orderDetai = _vm$data26.orderDetail) === null || _vm$data26$orderDetai === void 0 ? void 0 : (_vm$data26$orderDetai2 = _vm$data26$orderDetai.deliveryActivity) === null || _vm$data26$orderDetai2 === void 0 ? void 0 : (_vm$data26$orderDetai3 = _vm$data26$orderDetai2.returned) === null || _vm$data26$orderDetai3 === void 0 ? void 0 : _vm$data26$orderDetai3.createdAt)) + " ")])]) : _c('li', [_c('div', {
    staticClass: "row list-group-item"
  }, [_c('span', {
    style: `color: ${(_vm$data27 = _vm.data) !== null && _vm$data27 !== void 0 && (_vm$data27$orderDetai = _vm$data27.orderDetail) !== null && _vm$data27$orderDetai !== void 0 && (_vm$data27$orderDetai2 = _vm$data27$orderDetai.deliveryActivity) !== null && _vm$data27$orderDetai2 !== void 0 && (_vm$data27$orderDetai3 = _vm$data27$orderDetai2.completed) !== null && _vm$data27$orderDetai3 !== void 0 && _vm$data27$orderDetai3.deliveryStatusId ? 'var(--primary)' : ''}`
  }, [_c('c-success'), _c('span', {
    style: `color: ${(_vm$data28 = _vm.data) !== null && _vm$data28 !== void 0 && (_vm$data28$orderDetai = _vm$data28.orderDetail) !== null && _vm$data28$orderDetai !== void 0 && (_vm$data28$orderDetai2 = _vm$data28$orderDetai.deliveryActivity) !== null && _vm$data28$orderDetai2 !== void 0 && (_vm$data28$orderDetai3 = _vm$data28$orderDetai2.completed) !== null && _vm$data28$orderDetai3 !== void 0 && _vm$data28$orderDetai3.deliveryStatusId ? 'var(--primary)' : ''}`
  }, [_vm._v(" " + _vm._s(((_vm$$helper$findColor4 = _vm.$helper.findColor((_vm$$masterCrm4 = _vm.$masterCrm) === null || _vm$$masterCrm4 === void 0 ? void 0 : _vm$$masterCrm4.CrmDeliveryStatus, (_vm$data29 = _vm.data) === null || _vm$data29 === void 0 ? void 0 : (_vm$data29$orderDetai = _vm$data29.orderDetail) === null || _vm$data29$orderDetai === void 0 ? void 0 : (_vm$data29$orderDetai2 = _vm$data29$orderDetai.deliveryActivity) === null || _vm$data29$orderDetai2 === void 0 ? void 0 : (_vm$data29$orderDetai3 = _vm$data29$orderDetai2.completed) === null || _vm$data29$orderDetai3 === void 0 ? void 0 : _vm$data29$orderDetai3.deliveryStatusId, ['id'])) === null || _vm$$helper$findColor4 === void 0 ? void 0 : _vm$$helper$findColor4.name) || 'Completed') + " ")])], 1), (_vm$data30 = _vm.data) !== null && _vm$data30 !== void 0 && (_vm$data30$orderDetai = _vm$data30.orderDetail) !== null && _vm$data30$orderDetai !== void 0 && (_vm$data30$orderDetai2 = _vm$data30$orderDetai.deliveryActivity) !== null && _vm$data30$orderDetai2 !== void 0 && (_vm$data30$orderDetai3 = _vm$data30$orderDetai2.completed) !== null && _vm$data30$orderDetai3 !== void 0 && _vm$data30$orderDetai3.deliveryReason ? _c('span', {
    staticStyle: {
      "padding-left": "35px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v("Reason :")]), _c('span', {
    staticStyle: {
      "font-weight": "400",
      "color": "#000000"
    }
  }, [_vm._v(" " + _vm._s(((_vm$data31 = _vm.data) === null || _vm$data31 === void 0 ? void 0 : (_vm$data31$orderDetai = _vm$data31.orderDetail) === null || _vm$data31$orderDetai === void 0 ? void 0 : (_vm$data31$orderDetai2 = _vm$data31$orderDetai.deliveryActivity) === null || _vm$data31$orderDetai2 === void 0 ? void 0 : (_vm$data31$orderDetai3 = _vm$data31$orderDetai2.completed) === null || _vm$data31$orderDetai3 === void 0 ? void 0 : _vm$data31$orderDetai3.deliveryReason) || "N/A") + " ")])]) : _vm._e()]), _c('div', {
    staticClass: "row list-group-item"
  }, [_vm._v(" " + _vm._s((_vm$$helper5 = _vm.$helper) === null || _vm$$helper5 === void 0 ? void 0 : _vm$$helper5.formatDate((_vm$data32 = _vm.data) === null || _vm$data32 === void 0 ? void 0 : (_vm$data32$orderDetai = _vm$data32.orderDetail) === null || _vm$data32$orderDetai === void 0 ? void 0 : (_vm$data32$orderDetai2 = _vm$data32$orderDetai.deliveryActivity) === null || _vm$data32$orderDetai2 === void 0 ? void 0 : (_vm$data32$orderDetai3 = _vm$data32$orderDetai2.completed) === null || _vm$data32$orderDetai3 === void 0 ? void 0 : _vm$data32$orderDetai3.createdAt)) + " ")])])])])])])]), _c('div', {
    staticClass: "row pr27 pl27 mt12 mb24"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "cellspacing": "0"
    }
  }, [_vm._m(27), _c('tbody', [_vm._l(_vm.data.orderDetail.orderItems, function (orderItem, index) {
    return _c('tr', {
      key: (orderItem, index)
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _c('td', [_vm._v(_vm._s(orderItem.name))]), _c('td', {
      staticClass: "tr-right"
    }, [_vm._v(_vm._s(orderItem.quantity))]), _c('td', {
      staticClass: "tr-right"
    }, [_vm._v(" $" + _vm._s(orderItem.priceBeforeDiscount.toFixed(2)) + " ")]), _c('td', {
      staticClass: "tr-right"
    }, [_vm._v("$" + _vm._s(orderItem.totalAmount.toFixed(2)))])]);
  }), _c('tr', {
    staticClass: "tr"
  }, [_c('td', {
    staticClass: "tr-right",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Sub-Total")]), _c('td', {
    staticClass: "tr-right"
  }, [_vm._v(" $" + _vm._s(_vm.data.orderDetail.paymentDetail.subtotalAmount.toFixed(2)) + " ")])]), _vm.data.orderDetail.paymentDetail.discountAmount ? _c('tr', {
    staticClass: "tr"
  }, [_c('td', {
    staticClass: "tr-right",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Discount")]), _c('td', {
    staticClass: "tr-right"
  }, [_vm._v(" -$" + _vm._s(_vm.data.orderDetail.paymentDetail.discountAmount.toFixed(2)) + " ")])]) : _vm._e(), _c('tr', {
    staticClass: "tr"
  }, [_c('td', {
    staticClass: "tr-right",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Shipping Charge")]), _c('td', {
    staticClass: "tr-right"
  }, [_vm._v(" $" + _vm._s(_vm.data.orderDetail.paymentDetail.shippingRate.toFixed(2)) + " ")])]), _vm.data.orderDetail.paymentDetail.couponCode ? _c('tr', {
    staticClass: "tr"
  }, [_c('td', {
    staticClass: "tr-right",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" Coupon(" + _vm._s(_vm.data.orderDetail.paymentDetail.couponCode) + ") ")]), _c('td', {
    staticClass: "tr-right"
  }, [_vm._v(" -$" + _vm._s(_vm.data.orderDetail.paymentDetail.couponDiscountAmount.toFixed(2)) + " ")])]) : _vm._e(), _c('tr', {
    staticClass: "tr tr-color"
  }, [_c('td', {
    staticClass: "tr-right",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Total")]), _c('td', {
    staticClass: "tr-right"
  }, [_vm._v(" $" + _vm._s(_vm.data.orderDetail.paymentDetail.totalAmount.toFixed(2)) + " ")])])], 2)]), _c('div', {
    staticClass: "row mt12",
    attrs: {
      "hidden": ""
    }
  }, [_c('ul', {
    staticClass: "list-group"
  }, [_vm._m(28), _c('li', [_c('div', {
    staticClass: "split"
  }, [_c('label', {
    attrs: {
      "for": "remark"
    }
  }, [_vm._v("Remark")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.text,
      expression: "body.text"
    }],
    staticClass: "input outline-dark desc",
    attrs: {
      "type": "text",
      "id": "remark",
      "placeholder": "Write the remark..."
    },
    domProps: {
      "value": _vm.body.text
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.body, "text", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "split",
    attrs: {
      "hidden": ""
    }
  }, [_vm._m(29), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.body.orderStatusId,
      expression: "body.orderStatusId"
    }],
    staticClass: "mr6 filter-type",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.body, "orderStatusId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.data.orderStatus, function (orderStatus, index) {
    return _c('option', {
      key: (orderStatus, index),
      domProps: {
        "value": orderStatus.id
      }
    }, [_vm._v(" " + _vm._s(orderStatus.name) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "mt12",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [_c('button', {
    staticClass: "btn btn-light-secondary mr8",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(" Cancel ")]), !_vm.isUpdating ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.submitUpdateOrder
    }
  }, [_vm._v(" Save ")]) : _c('button', {
    staticClass: "btn btn-info"
  }, [_vm._v("Loading...")])])])])])])]) : _vm._e(), _vm.isFetching ? _c('TableLoading') : _vm._e()], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" Special Blend Order Detail ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5 text-capitalize"
  }, [_c('b', [_vm._v("Invoice No")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Transaction Number")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Payment Method")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Shipping Method")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Shipping Address")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Shipping Fee")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Ordered Date")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Ordered Status")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Reward Points")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Branch")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Provider")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Remark")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('i', {
    staticClass: "fas fa-user"
  }), _vm._v(" Customer")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Name")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Email")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Phone")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('i', {
    staticClass: "fas fa-money-check-alt"
  }), _vm._v(" Payment Detail")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Coupon Code/Discount")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Coupon Free Shipping")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5"
  }, [_c('b', [_vm._v("Payment Status")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v(" Delivery Information")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5 text-capitalize"
  }, [_c('b', [_vm._v("Delivery Option")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5 text-capitalize"
  }, [_c('b', [_vm._v("Delivery Address")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5 text-capitalize"
  }, [_c('b', [_vm._v("Delivery By")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-5 text-capitalize"
  }, [_c('b', [_vm._v("Delivery Contact")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticStyle: {
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fas fa-truck"
  }), _vm._v(" Delivery Status ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _c('th', [_vm._v("Product")]), _c('th', {
    staticClass: "tr-right"
  }, [_vm._v("Quantity")]), _c('th', {
    staticClass: "tr-right"
  }, [_vm._v("Unit Price")]), _c('th', {
    staticClass: "tr-right"
  }, [_vm._v("Total")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('i', {
    staticClass: "fas fa-edit"
  }), _vm._v("Add Remark")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-title"
  }, [_c('span', {
    staticClass: "txt-danger",
    staticStyle: {
      "line-height": "31px"
    }
  }, [_vm._v("*")]), _c('span', {
    staticClass: "line-h31 font14"
  }, [_vm._v("Status :")])]);

}]

export { render, staticRenderFns }